import { MoreOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';

import type { Employee } from '@pages/Calendar/data';

import { useEmployeeHeaderActions } from '../hooks';

import { EmployeeBreakActionModal } from './EmployeeBreakActionModal';
import { EmployeeWorkScheduleActionModal } from './EmployeeWorkScheduleActionModal';

import type { FC } from 'react';

import '../styles/EmployeeHeaderActions.scss';

interface EmployeeHeaderActionsProps {
  employee: Employee;
}

export const EmployeeHeaderActions: FC<EmployeeHeaderActionsProps> = ({
  employee,
}) => {
  const {
    isDropdownOpen,
    isPreparingAction,
    items,
    breakModalState,
    employeeId,
    workScheduleModalState,
    handleDropdownOpenChange,
    handleBreakModalSuccess,
    handleCloseBreakModal,
    handleCloseWorkScheduleModal,
  } = useEmployeeHeaderActions({ employee });

  return (
    <>
      <Dropdown
        trigger={['click']}
        placement="bottomRight"
        menu={{ items }}
        open={isDropdownOpen}
        onOpenChange={handleDropdownOpenChange}
        overlayClassName="EmployeeHeaderActions__overlay"
      >
        <Button
          type="text"
          size="small"
          className="EmployeeHeaderActions__trigger"
          data-testid={`employee-header-actions-trigger-${employee.id}`}
          aria-label={`Открыть меню действий исполнителя ${employee.name}`}
          icon={<MoreOutlined />}
          loading={isPreparingAction}
        />
      </Dropdown>

      {workScheduleModalState?.isOpen && (
        <EmployeeWorkScheduleActionModal
          employeeId={employeeId}
          employeeName={employee.name}
          initialTimeS={workScheduleModalState.initialTimeS}
          initialTimeE={workScheduleModalState.initialTimeE}
          initialWarningText={workScheduleModalState.initialWarningText}
          isOpen={workScheduleModalState.isOpen}
          mode={workScheduleModalState.mode}
          workScheduleId={workScheduleModalState.workScheduleId}
          onClose={handleCloseWorkScheduleModal}
        />
      )}

      {breakModalState?.isOpen && (
        <EmployeeBreakActionModal
          date={breakModalState.date}
          employeeId={employeeId}
          employeeName={employee.name}
          initialTimeS={breakModalState.initialTimeS}
          initialTimeE={breakModalState.initialTimeE}
          isOpen={breakModalState.isOpen}
          mode={breakModalState.mode}
          onClose={handleCloseBreakModal}
          onSuccess={handleBreakModalSuccess}
        />
      )}
    </>
  );
};
